import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { path } from "constant/pathLinksConstant";
import { useAuth } from "hooks/useAuth";
import { blackColor, primaryColor } from "theme";
import { AUTH_CONSTANTS } from "constant/authConstant";

import { usePostLoginMutation } from "../../redux/modules/onboarding";

const LoginModal = ({
  setCurrentPage,
  handleClose,
  setSnackbarData,
  setOpenSnackbar
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [postSignIn, { isLoading }] = usePostLoginMutation(
    {},
    {
      pollingInterval: 3000,
      refetchOnMountOrArgChange: true,
      skip: false
    }
  );
  const onSubmit = (data) => {
    const formData = data;
    postSignIn(formData)
      .unwrap()
      .then((dataR) => {
        login(dataR.result).then(() => {
          if (dataR.result.newUser === false) {
            handleClose();
          } else {
            handleClose();
            navigate(path.app.resetPassword, {state: { token: dataR.result.token }});
          }
        });
      })
      .catch((error) => {
        setOpenSnackbar(true);
        setSnackbarData({
          message: error.data.message || AUTH_CONSTANTS.SOMETHING_WENT_WRONG,
          severity: "error"
        });
      });
  };
  return (
    <>
      <Typography
        fontSize="24px"
        textAlign="center"
        fontWeight={700}
        id="parent-modal-title"
        className="modal-title"
      >
        Sign In to continue
      </Typography>

      <Box sx={{ width: "100%" }}>
        <FormControl
          sx={{
            mt: "2rem",
            mb: "1.5rem",
            bgcolor: "white",
            position: "relative"
          }}
          fullWidth
          variant="outlined"
        >
          <TextField
            size="small"
            label="Email"
            error={!!errors.email}
            sx={{
              width: "100%",
              bgcolor: "white",
              fieldset: { borderColor: "#C4CAD3" }
            }}
            placeholder="Ex: jack.callies@gmail.com"
            {...register("email", { required: true })}
            InputProps={{
              sx: {
                borderColor: "#C4CAD3",
                borderRadius: "4px",
                width: "100%",
                bgcolor: "white",
                maxHeight: "40px"
              }
            }}
            variant="outlined"
          />
        </FormControl>
        <FormControl
          sx={{
            bgcolor: "white",
            position: "relative",
            mb: "1.5rem"
          }}
          fullWidth
          variant="outlined"
        >
          <TextField
            size="small"
            label="Password"
            type="password"
            error={!!errors.password}
            {...register("password", { required: true })}
            sx={{
              width: "100%",
              bgcolor: "white",
              fieldset: { borderColor: "#C4CAD3" }
            }}
            placeholder="Ex: Auto & Services"
            InputProps={{
              sx: {
                borderColor: "#C4CAD3",
                borderRadius: "4px",
                width: "100%",
                bgcolor: "white",
                maxHeight: "40px"
              }
            }}
            variant="outlined"
          />
        </FormControl>
        <Typography fontSize=".875rem" color={primaryColor}>
          Forgot Password?
        </Typography>
        <Button
          sx={{
            mt: "1.5rem",
            width: "100%",
            height: "43px"
          }}
          variant="primary"
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Sign In
        </Button>
        <Typography
          sx={{ mt: "1rem" }}
          textAlign="center"
          fontSize="13px"
          color={blackColor}
        >
          Don’t have an account?{" "}
          <span
            onClick={() => setCurrentPage("signup")}
            style={{
              color: primaryColor,
              fontSize: ".875rem",
              cursor: "pointer"
            }}
          >
            Create Account
          </span>
        </Typography>
      </Box>
    </>
  );
};

export default LoginModal;
